import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Matrix } from '@shared/models/question-types/matrix';
import { OpenAnswerComponent } from '../open-answer/open-answer.component';
import { QuestionBaseComponent } from '../question-base/question-base.component';
import { MatrixMultiSelectComponent } from './matrix-multi-select/matrix-multi-select.component';
import { MatrixSingleSelectComponent } from './matrix-single-select/matrix-single-select.component';

@Component({
  selector: 'app-matrix',
  standalone: true,
  imports: [
    CommonModule,
    OpenAnswerComponent,
    MatrixSingleSelectComponent,
    MatrixMultiSelectComponent,
    TranslateModule,
    QuestionBaseComponent,
  ],
  templateUrl: './matrix.component.html',
  styleUrl: './matrix.component.scss',
})
export class MatrixComponent {
  @Input() matrixQuestion!: Matrix;
  @Input({ required: true }) form!: FormGroup<any>;
  @Input() isFirstQuestion = false;
}
